import { useCallback } from 'react';

import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';

import { DepositStackParamList } from '@/navigation/types';

import { setDepositAmount } from './use-deposit-status-store';

/**
 * Hook for handling available funds guidance from Trustly
 * @returns Callback function that sets the suggested amount and navigates to deposit screen
 */
export const useTrustlyHandleAvailableFundsGuidance = () => {
    const navigation = useNavigation<NativeStackNavigationProp<DepositStackParamList>>();

    const handleAvailableFundsGuidance = useCallback(
        (suggestedAmount: string) => {
            setDepositAmount(suggestedAmount);
            navigation.navigate('TrustlyFundsGuidance', { suggestedRetryAmount: suggestedAmount });
        },
        [navigation]
    );

    return handleAvailableFundsGuidance;
};
